export const ReadyRule = {
    "cancelManualCallReprogramed":"cancelManualCallReprogramed",
    "Logout":"Logout",
    "GetAgentID":"GetAgentID",
    "GetUserName":"getUserName",
    "GetExtension":"GetExtension",
    "ChangePassword":"ChangePassword",
    "sendClientChatMessage":"sendClientChatMessage",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getChatHistory":"getChatHistory",
    "GetCampaignsRelated":"GetCampaignsRelated",
    "makeManualCall":"makeManualCall",
    "getLastCallData":"getLastCallData",
    "getCallHistory":"getCallHistory",
    "getUnavailables":"getUnavailables",
    "getUnavailableHistory":"getUnavailableHistory",
    "getAuxiliarReadys":"getAuxiliarReadys",
    "getAuxiliarReadyStatus":"getAuxiliarReadyStatus",
    "setAuxiliarReady":"setAuxiliarReady",
    "changeAuxiliarToReady":"changeAuxiliarToReady",
};


// WEBPACK FOOTER //
// ./src/BusinessRule/ReadyRule.js